import Head from 'next/head';

import { PostOrPage } from '@tryghost/content-api';

interface IGhostMeta {
  content: PostOrPage;
  author?: {
    name: string;
  };
}

const GhostMeta = ({ content, author }: IGhostMeta) => {
  return (
    <Head>
      <title>{content.meta_title}</title>
      {/* TODO: Should we move it out of here? */}
      <link rel='shortcut icon' href='/favicon.png' />

      <meta name='description' content={content.meta_description || ''} />
      {/* <meta property="og:site_name" content="HackSoft&#x27;s Blog" /> */}
      <meta property='og:type' content='article' />
      <meta property='og:title' content={content.og_title || content.meta_title || ''} />
      <meta
        property='og:description'
        content={content.og_description || content.meta_description || ''}
      />
      <meta property='og:image' content={content.og_image || content.feature_image || ''} />
      <meta property='article:published_time' content={content.published_at || ''} />
      <meta property='article:modified_time' content={content.updated_at || ''} />
      <meta name='publish_date' property='article:tag' content={content.primary_tag?.name} />

      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:title' content={content.twitter_title || content.meta_title || ''} />
      <meta
        name='twitter:description'
        content={content.twitter_description || content.meta_description || ''}
      />
      <meta name='twitter:image' content={content.twitter_image || content.feature_image || ''} />
      <meta name='twitter:site' content='@HackSoft_' />

      {author && (
        <>
          <meta name='author' content={`${author.name}`} />
          <meta name='twitter:label1' content='Written by' />
          <meta name='twitter:data1' content={`${author.name}`} />
        </>
      )}
    </Head>
  );
};

export default GhostMeta;
